<template>
  <div class="form-class">
    <form  v-on:submit.prevent='loginHandle(loginId, password)' v-bind:style="{ backgroundColor: (buttonName === 'Login') ? 'rgba(255,255,255,0.10)' : '#FFF'}">
        <div style="display: none;">
          <input type="hidden" name="_wpcf7" value="4" />
        </div>
        <div class="heading heding-color" v-if="buttonName === 'Login'">{{"Login" | translate}}</div>
        <div class="heading heding-color" v-if="buttonName !== 'Login'">{{"Login" | translate}}</div>
        <div class="cursor close" @click="closePopup" v-if="buttonName !== 'Login'">X</div>
        <div class="input-section top-mrgn input-btm-mrg">
            <img src="/static/images/user-icon.png">
            <input type="text" id="login-id" autofocus @focus="changeEditingField('username')" name="login_id" autocomplete="off" placeholder="Username" v-model="loginId">
        </div>
        <div class="input-section">
            <img src="/static/images/password-icon.png">
            <input type="password" id="password" @focus="changeEditingField('password')" name="password" placeholder="Password" v-model="password">
        </div>
        <div class="btn-bg1">
          <div class="btn-bg2">
            <button class="cursor login">{{buttonName | translate}}</button>
          </div>
        </div>
        <!-- <button class="cursor login">{{buttonName | translate}}</button> -->
        <!-- <div v-if="!userAction" class="cursor fp">{{forgotPwText | translate}}</div> -->
        <div v-if="userNotFount && !errorMsg" class="error-msg">{{userNotFount | translate}}</div>
        <div v-if="errorMsg && !userNotFount" class="error-msg">{{errorMsg | translate}}</div>
    </form>
    <!-- <div class="keyboard hide" >
      <Keypad @change="changeUserName" v-if="editingPlace === 'username'" :username="loginId"/>
      <Keyboard @change="changePassword" v-if="editingPlace !== 'username'" :username="password"/> -->

      <!-- <Keyboard @change="changeUserName" :username="loginId" v-if="editingValue === 'username'" />
      <PasswordKeyBoard @change="changePassword" :username="password" v-if="editingValue !== 'username'" /> -->
    <!-- </div> -->
  </div>
</template>
<script>
import Keypad from './keypad'
import Keyboard from './keypad1'

export default {
  name: 'Login',
  data () {
    return {
      loginId: null,
      forgotPwText: 'Forgot Password?',
      password: null,
      userNotFount: null,
      editingPlace: 'username'
    }
  },
  computed: {
    editingEnabled () {
      return this.editingValue
    }
  },
  props: ['userAction', 'token', 'errorMsg', 'buttonName'],
  created: function (e) {
    // console.log(this.userAction, this.token)
  },
  components: {
    Keypad,
    Keyboard
  },
  methods: {
    changeUserName (a) {
      this.loginId = a
    },
    changePassword (a) {
      this.password = a
    },
    changeEditingField (a) {
      this.editingPlace = a
    },
    loginHandle (loginId, password) {
      let vm = this
      if (loginId && password) {
        this.$emit('checkUser', {
          loginId, password
        })
      } else {
        vm.userNotFount = 'Enter valid details'
        setTimeout(() => {
          vm.userNotFount = false
        }, 3000)
      }
    },
    closePopup () {
      this.$emit('closePopup')
    }
  }
}
</script>
<style scoped>
    .input-section {
        width: 100%;
        position: relative;
    }
    .input-section img {
        width: 20px;
        position: absolute;
        top: 5px;
        left: 10px;
        z-index: 4
    }
    .input-section input {
        background: transparent;
        position: relative;
        vertical-align: top;
        border: none;
        border-bottom: 1px solid #812d03;
        display: -moz-inline-stack;
        display: inline-block;
        outline: none;
        height: 38px;
        width: 100%;
        padding: 0 15px;
        text-align: left;
        text-indent: 35px;
        font-size: 18px;
        font-family: 'Lato', sans-serif;
        color: #812d03;
    }
    div[dir='rtl'] .input-section input {
      text-align: right;
      text-indent: 5px;
    }
    /* .input-section input:focus {
        color: white;
        background: rgba(0, 0, 0, 0.5);
        border: 1px solid rgba(80, 72, 47, 0.4);
        -webkit-box-shadow: 0px 0px 3px rgba(80, 72, 47, 0.4) inset;
        -moz-box-shadow: 0px 0px 3px rgba(80, 72, 47, 0.4) inset;
        -o-box-shadow: 0px 0px 3px rgba(80, 72, 47, 0.4) inset;
        box-shadow: 0px 0px 3px rgba(80, 72, 47, 0.4) inset;
        outline: none;
    } */
    .cursor {
        cursor: pointer;
    }
    .fp {
        color: #FFF;
        text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
        font-weight: bolder;
    }
    ::-webkit-input-placeholder { /* Chrome/Opera/Safari */
        color: #812d03;
    }
    ::-moz-placeholder { /* Firefox 19+ */
        color: #812d03;
    }
    :-ms-input-placeholder { /* IE 10+ */
        color: #812d03;
    }
    :-moz-placeholder { /* Firefox 18- */
        color: #812d03;
    }
    form {
      border-radius: 10px;
      background-color: rgb( 255, 255, 255 );
      width: 100%;
      height: 100%;
      padding: 36px 41px;
      position: relative;
      max-height: 550px;
    }
    .top-mrgn {
      margin-top:77px;
    }
    .close {
      position: absolute;
      right: 15px;
      top: 15px;
      color: #812d03;
      font-weight: bold;
    }
    .form-class {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .hide {
      display: none;
    }
    div[dir='rtl'] .input-section img {
        left: initial;
        right: 10px;
      }
      div[dir='rtl'] input {
        text-indent: 35px !important;
      }

  @media only screen and (min-width: 2000px) {
      .input-section img {
        width:100px;
      }
      .input-section input {
        height: 150px;
        border-bottom-width: 5px;
        font-size: 80px;
        text-indent: 130px;
      }
      .keyboard {
        position: fixed;
        bottom: 0;
        height: 40%;
        width: 100%;
        left: 0;
      }
      form {
        max-height: initial !important;
      }
      .close {
        font-size: 100px;
        line-height: 100px;
        right: 50px;
        top: 50px;
      }

      div[dir='rtl'] .close {
        left: 50px;
        right: initial;
      }
      div[dir='rtl'] .input-section img {
        left: initial;
        right: 10px;
      }
      div[dir='rtl'] input {
        text-indent: 120px !important;
      }

  }

</style>



// WEBPACK FOOTER //
// src/components/login-form.vue